import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';
import { useQueryClient } from 'react-query';

export type Marketplace = 'wb' | 'ozon';

interface MarketplaceContextType {
	currentMarketplace: Marketplace;
	setCurrentMarketplace: (marketplace: Marketplace) => void;
	isWB: boolean;
	isOzon: boolean;
	switchMarketplace: (marketplace: Marketplace) => void;
}

const MarketplaceContext = createContext<MarketplaceContextType | undefined>(undefined);

export const useMarketplace = () => {
	const context = useContext(MarketplaceContext);
	if (!context) {
		throw new Error('useMarketplace must be used within a MarketplaceProvider');
	}
	return context;
};

interface MarketplaceProviderProps {
	children: ReactNode;
}

export const MarketplaceProvider: React.FC<MarketplaceProviderProps> = ({ children }) => {
	const [currentMarketplace, setCurrentMarketplace] = useState<Marketplace>('wb');
	const queryClient = useQueryClient();

	const switchMarketplace = useCallback((marketplace: Marketplace) => {
		if (marketplace !== currentMarketplace) {
			// Очищаем кэш запросов при переключении маркетплейса
			queryClient.clear();
			setCurrentMarketplace(marketplace);
		}
	}, [currentMarketplace, queryClient]);

	const value: MarketplaceContextType = {
		currentMarketplace,
		setCurrentMarketplace: switchMarketplace,
		isWB: currentMarketplace === 'wb',
		isOzon: currentMarketplace === 'ozon',
		switchMarketplace,
	};

	return (
		<MarketplaceContext.Provider value={value}>
			{children}
		</MarketplaceContext.Provider>
	);
}; 